import api from "config/api";
import { AppDispatch, RootState } from "store";
import { setAllCartData, setCartBtnLoading } from "store/slices/main.slice";

const sanitizeCartPayload = (value: any): any => {
  const seen = new WeakMap<object, any>();
  const omitKeys = new Set([
    "sourceDealPizza",
    "existingFullNote",
    "existingPizzaSize",
    "existingSizePrice",
    "existingPizzaCrust",
    "existingSpiceLevel",
    "existingSubTotal",
  ]);

  const visit = (input: any): any => {
    if (input === null || typeof input !== "object") return input;
    if (seen.has(input)) return seen.get(input);

    if (Array.isArray(input)) {
      const arr = input.map(visit);
      seen.set(input, arr);
      return arr;
    }

    const out: any = {};
    seen.set(input, out);

    Object.keys(input).forEach((key) => {
      if (omitKeys.has(key)) return;
      out[key] = visit(input[key]);
    });

    return out;
  };

  return visit(value);
};

export const addUpdateToCart =
  (item: any, onClose: () => void) =>
  (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch(setCartBtnLoading(true));

    const state = getState();
    const userId = state?.main?.userData?.clientId;

    if (!userId) {
      if (item?.data.isEdit) {
        const updatedCart = [...state.main.cart];
        updatedCart[item.data.index] = {
          ...item,
          cartId: state.main.cart[item.data.index].cartId,
        };
        dispatch(setAllCartData(updatedCart));
      } else {
        dispatch(setAllCartData([...state.main.cart, { ...item, cartId: 0 }]));
      }
      onClose();
      dispatch(setCartBtnLoading(false));
      // toast.error("User not authenticated");
      return;
    }

    if (item?.data.isEdit) {
      const sanitizedItem = sanitizeCartPayload(item);
      api
        .post("/api/Cart/UpdateCart", [
          {
            ...sanitizedItem,
            cartId: state.main.cart[item.data.index].cartId,
            userId,
          },
        ])
        .then(({ data }) => {
          const updatedCart = [...state.main.cart];
          updatedCart[item.data.index] = {
            ...item,
            cartId: state.main.cart[item.data.index].cartId,
          };
          dispatch(setAllCartData(updatedCart));
          onClose();

          console.log("Updated cart", data);
        })
        .catch((e) => {
          console.log("Error updating cart", e);
          // toast.error("Something went wrong while updating cart");
        })
        .finally(() => {
          dispatch(setCartBtnLoading(false));
        });
    } else {
      const sanitizedItem = sanitizeCartPayload(item);
      api
        .post("/api/Cart/AddCart", [{ ...sanitizedItem, cartId: 0, userId }])
        .then(({ data }) => {
          if (data.orderId) {
            dispatch(
              setAllCartData([
                ...state.main.cart,
                { ...item, cartId: data.orderId },
              ])
            );
            onClose();

            console.log("Added to cart", data);
          }
        })
        .catch((e) => {
          console.log("Error adding to cart", e);
          // toast.error("Something went wrong while adding to cart");
        })
        .finally(() => {
          dispatch(setCartBtnLoading(false));
        });
    }
  };
